import {useCallback, useEffect, useRef} from 'react';
import styled from 'styled-components';
import {Z_INDEX} from '@/styles';
import {PovMarker} from './PovMarker';

interface IProps {
  center?: naver.maps.LatLng;
  rotate: number;
  onClick?(pos: naver.maps.LatLng): void;
}

const MINI_MAP_DOM_ID = 'myfc--panorama-minimap-container';

export const MiniMap = ({center, rotate, onClick}: IProps) => {
  const map = useRef<naver.maps.Map>();

  const handleClick = useCallback(
    (e: {coord: naver.maps.LatLng}) => {
      onClick?.(e?.coord);
    },
    [onClick]
  );

  useEffect(() => {
    const minimap = new naver.maps.Map(MINI_MAP_DOM_ID, {
      center,
      scaleControl: false,
      mapDataControl: false,
      logoControl: false,
      mapTypeControl: false,
    });

    map.current = minimap;

    naver.maps.Event.once(minimap, 'init_stylemap', () => {
      const layer = new naver.maps.StreetLayer();
      layer.setMap(minimap);
      naver.maps.Event.addListener(minimap, 'click', handleClick);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (center && map.current) {
      map.current.setCenter(center);
    }
  }, [center]);

  return (
    <Root>
      <div id={MINI_MAP_DOM_ID}>
        {map?.current && (
          <PovMarker map={map.current} position={center} rotate={rotate} />
        )}
      </div>
    </Root>
  );
};

const Root = styled.div`
  position: fixed;
  width: 320px;
  height: 240px;
  left: 24px;
  bottom: 24px;
  z-index: ${Z_INDEX.globalFloating - 9};
  #${MINI_MAP_DOM_ID} {
    width: 100%;
    height: 100%;
  }
`;
